<template>
  <div id="app" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <div v-if="isGlobalLoading" class="global-loader" aria-live="polite" aria-busy="true">
      <span class="global-loader__spinner" aria-hidden="true"></span>
      <span class="global-loader__text">Loading</span>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { requestTracker } from "@/common/api.service";

export default {
  name: "App",

  computed: {
    isGlobalLoading() {
      return requestTracker.pendingRequests > 0;
    }
  },

  watch: {
    $route() {
      this.$store.commit("draggable/deselectAll");
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/_global.scss";
@import "@/styles/_type.scss";

.vue-notifyjs.notifications {
  .alert {
    z-index: 10000;
  }
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }
  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }
  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}

.dir-rtl {
  direction: rtl;
  text-align: right;
}

.global-loader {
  align-items: center;
  background: rgba(12, 12, 12, 0.8);
  border-radius: 999px;
  color: #fff;
  display: inline-flex;
  font-size: 11px;
  font-weight: 600;
  gap: 8px;
  letter-spacing: 0.06em;
  padding: 8px 12px;
  pointer-events: none;
  position: fixed;
  right: 20px;
  text-transform: uppercase;
  top: 20px;
  z-index: 12000;
}

.global-loader__spinner {
  animation: global-loader-spin 0.8s linear infinite;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-radius: 50%;
  border-top-color: #fff;
  display: inline-block;
  height: 14px;
  width: 14px;
}

@keyframes global-loader-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
